import { lt, useToggle } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { TextKey, RouteName } from '@mews-commander/enums';
import { WithGuideLink } from '@mews-commander/types';
import { LocalizedPageTitle, PortfolioLayout, PortfolioLayoutHeader, Tabs } from '@mews-commander/ui';
import { FilterSidebarLayoutContent } from '@mews-commander/modules/src/components/layout';
import { useTabsConfig } from '@mews-commander/modules/src/modules/modalManager';
import { useUserDetailContext } from '../../../context/userDetailContext';
import { defaultFilterValues, filterSchema, FilterValues } from '../filterSchema';
import { FilterFields } from '../FilterFields';
import { UsersTable } from './UsersTable';
import { ExportUsersButton } from './ExportUsersButton';

export const MultiPropertyUsers: React.FC<React.PropsWithChildren<WithGuideLink & { activeTab: Mews.TextKey }>> = ({
    guideLink,
    activeTab,
}) => {
    const resolveRoute = useResolveRoute();

    const { closeUserDetail } = useUserDetailContext();

    const tabsConfig = useTabsConfig({
        tabs: [
            {
                key: TextKey.PropertyUsers,
                url: resolveRoute(RouteName.UserManagementMultiPropertyPropertyUsersIndex),
                'data-test-tab': 'property-users',
            },
            {
                key: TextKey.PortfolioUserPlural,
                url: resolveRoute(RouteName.UserManagementMultiPropertyCentralUsersIndex),
                'data-test-tab': 'central-users',
            },
        ],
        activeTab,
        onTabClick: closeUserDetail,
    });

    const [showSidebar, toggleSidebar] = useToggle();

    return (
        <PortfolioLayout>
            <PortfolioLayoutHeader
                title={<LocalizedPageTitle textKey={TextKey.UserPlural} />}
                guideLink={guideLink}
                rightSide={<ExportUsersButton />}
            />
            <Tabs
                activeTabValue={tabsConfig.activeTabValue}
                onTabClick={tabsConfig.handleTabClick}
                underline
                inline
                showDivider
            >
                {tabsConfig.tabs}
            </Tabs>
            <FilterSidebarLayoutContent<FilterValues>
                showSidebar={showSidebar}
                toggleSidebar={toggleSidebar}
                filterSchema={filterSchema}
                filterSidebar={{ title: lt(TextKey.Filter), fields: <FilterFields /> }}
                defaultFilterValues={defaultFilterValues}
                submitButtonLabel={lt(TextKey.Filter)}
                withClearFilters
            >
                {({ filterValues }) => <UsersTable filterValues={filterValues} toggleSidebar={toggleSidebar} />}
            </FilterSidebarLayoutContent>
        </PortfolioLayout>
    );
};
